import React,{useState, useContext} from 'react'
import {ButtonLoader} from '../../utils/Loaders/ButtonLoader';
import PhoneInput from 'react-phone-number-input';
import { isMobile } from "react-device-detect";
import { useFetch } from '../../api/FetchApiData';
import { AppContext } from '../../../AppContextProvider';
import { useTranslation } from 'react-i18next';
import CG from '../../cgu/CG';
import Popup from 'reactjs-popup';
if (isMobile)
    import('./form_mob.css').then(() => {});
  else
    import('./form.css').then(() => {});


const useConditions=()=>
{
        return(
            <Popup trigger={<input type='button' value="Conditions d'utlisation" style={{height:'30px',border:'none',borderRadius:'10px',width:'100%',backGroundColor:'lightgray'}} />}>
                {(close)=><div id="user-cond" style={{width:'100%',height:'50vh',textAlign:'left',marginTop:'15px'}}>
                    <div style={{textAlign:'center',height:'95%',border:'1px solid lightgray',fontSize:'x-small',backgroundColor:'whitesmoke',padding:'0px 10px 20px 20px',borderRadius:'10px',overflowY:'scroll'}}>
                        <CG close={close} />
                    </div>
                </div>}
            </Popup>
            );
}

function InscriptionForm({setNotification = ()=>{},setConFormIsSelected, setUserId}) 
{
    const [data,setData] = useState({'username':'username'});
    const [charteColor,setCharteColor] = useState("black");
    const [colorEmail,setColorEmail] = useState("darkgray");
    const [colorCpass,setColorCpass] = useState("darkgray");
    const [charte,setCharte] = useState(false);
    const [loading,setLoading] = useState(false);
    const [topform,setTopForm] = useState('50%');
    const [AppState,setAppState] = useContext(AppContext);
    const fetchData = useFetch();
    const {t} = useTranslation();

    console.log(AppState.settings);

    const HandleData=(htmlElement)=>
    {
        if(htmlElement.target.name==='cpassword')
        {
            if(htmlElement.target.value!==data['password'])
                setColorCpass("red");
            else
                setColorCpass("darkgray");
            return;
        }
        else
        {
            data[htmlElement.target.name] = htmlElement.target.value.replace(/'/g,"''");
        }

        if(htmlElement.target.name==='email')
        {
            if(validateEmail(htmlElement.target.value))
            {setColorEmail("red");return}
            else{setColorEmail("red");}
        }
    }

    const HandlePhone=(value,isNumber)=>
    {
        setNotification({"origine":"","value":""});
        if(isNumber)
        {
            data["phone"] = value;
        }
    }

    const validateEmail=(email)=>
    {
        return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    }

    const RegistrationRequest=()=>
    {
        if(charte)
        {
            data['username'] = data['email'];
            fetchData.PostData(data,'user/register/').then((result)=>{
                if(!result.result)
                {
                    setNotification({"origine":'inscription',"value":"exist"});
                }
                else
                {
                    setNotification({"origine":'inscription',"value":"success"});
                    setConFormIsSelected(3);
                    setUserId(result.user_id);
                }
            });
        }
        else
        {
            setCharteColor("red");
        }
    };
  
    return (
        <div className="Form">
            <form className='form-form' onSubmit={e=>{e.preventDefault(); RegistrationRequest();}}>
                <div className="inputDiv" style={{display:'flex',flexDirection:(AppState.settings.lang==='ar')?'row-reverse':'row'}}>
                    <label>{t('authentication.nom')}</label>
                    <input onChange={e=>{HandleData(e)}} defaultValue={data.name} name="last_name" type="text" placeholder={t("authentication.nom")} />
                </div>
                <div className="inputDiv" style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                    <label>{t('authentication.prenom')}</label>
                    <input onChange={e=>{HandleData(e)}} defaultValue={data.prenom} name="first_name" type="text" placeholder={t("authentication.prenom")} />
                </div>
                <div className="inputDiv" style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                    <label>{t('authentication.email')}</label>
                    <input onChange={e=>{HandleData(e)}} name="email" defaultValue={data.email} type="email" placeholder={t("authentication.email")} />
                </div>
                <div className="inputDiv" style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                    <label>{t('authentication.telephone')}</label>
                    <div id="inputTel">
                        <PhoneInput name="phone" defaultCountry={'KM'} defaultValue={data.phone} onCountryChange={(e)=>{HandlePhone(e,false)}} placeholder={t("authentication.telephone")} onChange={(e)=>{HandlePhone(e,true)}}/>
                    </div>
                </div>
                <div className="inputDiv" style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                    <label>{t('authentication.mot-de-passe')}</label>
                    <input onChange={e=>{HandleData(e);setNotification({"origine":"password","value":""});}} defaultValue={data.password} name="password" type="password" placeholder="*************" />
                </div>
                <div className="inputDiv" style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                    <label>{t('authentication.confirmation-mot-de-passe')}</label>
                    <input onChange={e=>{HandleData(e);}} name="cpassword" style={{border: "1px solid "+colorCpass}} type="password" placeholder="*************" />
                </div>
                <div id="inputChart" style={{margin:'auto',marginTop:"15px",marginBottom:"15px",width:'80%'}}>
                    <input onClick={e=>{setCharte(e.target.checked)}} name="charte" type="checkbox" style={{border:"1px solid "+charteColor,width:'20px',height:'15px'}} /> <label style={{fontSize:'small'}}>{t('authentication.agree-terms')}</label>
                </div>
                <div className="btnSubmit" style={{}}>
                    <ButtonLoader loading={loading} onSubmit={e=>{RegistrationRequest();}} text={t("authentication.envoyer")} style={{backGroundColor:'yellowgreen',fontSize:'small'}} />                    
                </div>
                <input onClick={e=>{setConFormIsSelected(1);setTopForm('100px');}} type="button" className="btnSubmit" style={{backgroundColor:'lightgray'}} value={t("authentication.connexion")}></input>
                <div style={{width:'50%',margin:'auto',marginTop:'20px'}}>
                    {useConditions()}
                </div>
            </form>
        </div>);
}


export default InscriptionForm
